import { Component, OnInit, inject } from '@angular/core';
import { Observable, BehaviorSubject, animationFrameScheduler, scheduled, lastValueFrom} from 'rxjs';
import { debounceTime, map, switchMap } from 'rxjs/operators';
import { LoadingAwareComponent } from 'src/app/common/utils/loading-aware.component';
import { DeviceManagementDeviceApiClient, DeviceFilters, FleetIndexResponse, Device }
  from 'src/app/api/api-device-management.service.generated';
import { MatDialog, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';
import { ButtonComponent } from "wecheer-common";

@Component({
    selector: 'app-select-device-popup',
    templateUrl: './select-device-popup.component.html',
    styleUrls: ['./select-device-popup.component.scss'],
    imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatButtonModule,
    AsyncPipe,
    ButtonComponent
]
})
export class SelectDevicePopupComponent extends LoadingAwareComponent implements OnInit {
  private client = inject(DeviceManagementDeviceApiClient);
  dialogRef = inject<MatDialogRef<SelectDevicePopupComponent>>(MatDialogRef);

  public devices$: Observable<Device[]>;
  private querySubject = new BehaviorSubject<string>('');

  constructor() {
    super();
    this.devices$ = this.querySubject.pipe(
      debounceTime(300),
      switchMap(text => {
        if (text.length < 5) {
          return scheduled([new FleetIndexResponse({data: []})], animationFrameScheduler);
        }
        return this.withLoading(this.client.searchDevices2(new DeviceFilters({mac: [text]})));
      }),
      map(response => {
        return response['data'];
      })
    );
  }

  ngOnInit() {
  }

  static async open(dialog: MatDialog): Promise<Device | undefined> {
    const result = await lastValueFrom(dialog.open(
      SelectDevicePopupComponent,
      {
        width: '600px',
      }
    ).afterClosed());
    return result as (Device | undefined);
  }

  onChange(newValue: string) {
    this.querySubject.next(newValue);
  }

  selectDevice(device: Device) {
    this.dialogRef.close(device);
  }
}
